// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class Color {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): Color {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  bitsR(): number {
    return this.bb!.readUint8(this.bb_pos)
  }

  bitsG(): number {
    return this.bb!.readUint8(this.bb_pos + 1)
  }

  bitsB(): number {
    return this.bb!.readUint8(this.bb_pos + 2)
  }

  bitsA(): number {
    return this.bb!.readUint8(this.bb_pos + 3)
  }

  static sizeOf(): number {
    return 4
  }

  static createColor(
    builder: flatbuffers.Builder,
    bits_r: number,
    bits_g: number,
    bits_b: number,
    bits_a: number
  ): flatbuffers.Offset {
    builder.prep(1, 4)
    builder.writeInt8(bits_a)
    builder.writeInt8(bits_b)
    builder.writeInt8(bits_g)
    builder.writeInt8(bits_r)
    return builder.offset()
  }
}
